import { render } from "./packages_kinds.html?vue&type=template&id=bc72acf6&scoped=true&external"
import script from "./packages_kinds.vue?vue&type=script&lang=js"
export * from "./packages_kinds.vue?vue&type=script&lang=js"

import "./packages_kinds.vue?vue&type=style&index=0&id=bc72acf6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc72acf6"]])

export default __exports__